<template>
  <collapsible-widget
    icon="map"
    colorBadge="transparent"
    :collapsed="collapsed"
  >
    <div class="divtest" id="divtest" style="width:100%">
      <!-- TO DO: corriger le fait qu'en cas de plusisuers MAP il y aura plusieurs ID identiques -->
      <map id="carte" name="carte">
        <area
          shape="rect"
          :coords="`${coordA},${coordB},${coordC},${coordD}`"
          @click="
            $store.getters.isPlaying
              ? confirm_exit()
              : $bvModal.show('testmodal')
          "
          data-reveal-id="testmodal"
        />
      </map>
      <img id="test" usemap="#carte" :src="src" alt="..." @load="resize" />
    </div>
    <b-modal
      id="testmodal"
      ref="modal"
      :title="$t('submit_parameter')"
      hide-footer
    >
      <component
        v-for="element in config.elements"
        :key="element.id"
        :is="getComponentName(element)"
        :config="element"
        style="margin-bottom:15%;"
      ></component>
      <md-button class="mt-3" block @click="submit(model_group)">{{
        $t("submit")
      }}</md-button>
    </b-modal>
  </collapsible-widget>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
//import Modal from "vue-material-kit-pro/src/components/Modal.vue";

export default {
  name: "MapInputComponent",
  mixins: [componentMixin, inputComponentMixin],
  components: { CollapsibleWidget },
  data() {
    return {
      classicModal: false,
      imgHeight: 0,
      coordA: 0,
      coordB: 0,
      coordC: 0,
      coordD: 0
    };
  },
  async load() {
    //this.resize();
  },
  async mounted() {
    this.resize();
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  computed: {
    src() {
      return `${this.IREALCONFIG.static_ressources}/${this.attributes.src}`;
    },
    ratios() {
      return this.attributes.ratios.split("|");
    },
    id() {
      return this.attributes.id ? this.attributes.id : "modal-1";
    },
    options() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    }
  },
  methods: {
    classicModalHide() {
      this.classicModal = false;
    },
    resize() {
      // tool to find coordinates of rect on origin picture: https://www.image-map.net/
      // coord = point supérieur gauche ( x et y ) et point inférieur droit (x et y)
      var test = document.getElementById("test");
      var divtest = document.getElementById("divtest");
      this.imgHeight =
        divtest.clientWidth / (test.naturalWidth / test.naturalHeight);
      this.coordA = Math.round(parseInt(divtest.clientWidth) * this.ratios[0]);
      this.coordB = Math.round(parseInt(this.imgHeight) * this.ratios[1]);
      this.coordC = Math.round(parseInt(divtest.clientWidth) * this.ratios[2]);
      this.coordD = Math.round(parseInt(this.imgHeight) * this.ratios[3]);
    },
    submit() {
      this.$bvModal.hide("testmodal");
    }
  }
};
</script>
